import { render, staticRenderFns } from "./CompetitionFilterDefaultLayout.vue?vue&type=template&id=20d554b2&scoped=true&"
import script from "./CompetitionFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d554b2",
  null
  
)

export default component.exports